<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :details="details"/>
      </div>
    </div>

    <Items class="block" :items="details.Items"/>
    <Total class="block" :details="details"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../HpadModel.js";
import Services from "../../../services/Api/HppAdjServices.js";

import Details from "./HpadPD_Details.vue";
import Items from "./HpadPD_Items.vue";
import Total from "./HpadPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Items,
    Total,
    Company
  },
  data: () => ({
    details: {},
    companyData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.details = data.Details;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>